import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"white-space":"nowrap"} }
const _hoisted_2 = { class: "body-2" }
const _hoisted_3 = { class: "body-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_back, { onClick: _ctx.endAnalysis }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex justify-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                rounded: "",
                elevation: "0",
                onClick: _ctx.groupAnalysis,
                disabled: _ctx.disabledGroup,
                size: "small"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Regrouper ")
                ])),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.companies)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "rounded-lg",
                    height: "80vh",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createElementVNode("h4", null, "Analyse des SIREN", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn_prev, {
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.idx--)),
                                    size: "small"
                                  }),
                                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.idx) + "/" + _toDisplayString(_ctx.total), 1),
                                  _createVNode(_component_v_btn_next, {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.idx++)),
                                    size: "small"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { class: "ma-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                rounded: "",
                                elevation: "0",
                                class: "mr-2 mt-1",
                                onClick: _ctx.selectAll,
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode(" Tout sélectionner ")
                                ])),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                outlined: "",
                                rounded: "",
                                elevation: "0",
                                class: "ml-2 mt-1",
                                onClick: _ctx.clearAll,
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode(" Tout désélectionner ")
                                ])),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "5" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies.analysis, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  (_ctx.idx - 1 === index)
                                    ? (_openBlock(), _createBlock(_component_v_card, {
                                        key: 0,
                                        class: "ml-2 rounded-lg",
                                        height: "58vh",
                                        elevation: "0",
                                        outlined: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (itm) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: itm.id,
                                              class: "oss-list-item ma-1"
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: _ctx.currentCompanies,
                                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentCompanies) = $event)),
                                                  value: itm
                                                }, null, 8, ["modelValue", "value"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(itm)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(itm.siret), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(itm.groupKey), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createElementVNode("div", _hoisted_2, _toDisplayString(itm.address) + " " + _toDisplayString(itm.city), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-large" }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createTextVNode("$keyboard_tab")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "5" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "mr-2 rounded-lg",
                                height: "58vh",
                                elevation: "0",
                                outlined: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCompanies, (itm) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: itm.id,
                                      class: "ma-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getFullCompanyName(itm)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(itm.siret), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(itm.groupKey), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createElementVNode("div", _hoisted_3, _toDisplayString(itm.address) + " " + _toDisplayString(itm.city), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}